import React from "react"
import FontIcon from "material-ui/FontIcon"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import MapLoader from "./MapLoader"
interface IProps {
    lat: number
    lng: number
    index: string | number
}
interface IState {
    open: boolean
    location: { lat: number, lng: number },
    showLocationMap: boolean
}

export default class MapColumn extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        let lat, lng, showLocationMap
        if (props.lat) {
            lat = props.lat
            lng = props.lng
            showLocationMap = true
        } else {
            lat = 0
            lng = 0
            showLocationMap = false
        }

        this.state = {
            open: false,
            location: { lat: lat, lng: lng },
            showLocationMap
        }
    }

    render() {
        return (
            <div>
                <ToolTip active={this.state.open} position="left" arrow="center" parent={"#" + "map-" + this.props.index} key={"map-" + this.props.index}>
                    {this.state.showLocationMap ?
                        <div style={{ width: 300, height: 300 }}>
                            <section style={{ height: "100%" }}>
                                <MapLoader
                                    locations={[this.state.location]}
                                />
                            </section>
                        </div> :
                        <div style={{ width: 320, height: 75, textAlign: "center" }}>
                            <h3>{strings.No_Location}</h3>
                            {strings.Punch_added_manually}
                        </div>
                    }
                </ToolTip>
                <FontIcon
                    className="fa fa-globe"
                    id={"map-" + this.props.index}
                    style={{ color: !this.state.showLocationMap && "#cccccc" }}
                    onMouseOver={() => this.setState({ open: true })}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}
